import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {DatePicker, Spin} from 'antd'
import moment from 'moment'
import Modal from './Modal'

import style from './debug.sass'

@inject('store') @observer
class Debug extends Component {
  state = {
    modal: false
  }
  componentDidMount() {
    const id = this.props.match.params.paperID
    this.props.store.paperTrading.debug.setId(id)
    this.props.store.paperTrading.debug.checkStatus()
  }
  componentDidUpdate() {
    if (!this.props.store.user.is_admin && !!this.props.store.user.username) {
      this.props.history.push('/')
    }
  }
  changeHandler = (date, dateString) => {
    this.props.store.paperTrading.debug.changeDate(dateString)
  }
  submitHandler = e => {
    e.preventDefault()
    this.setState({modal: true})
  }
  closeModal = () => {
    this.setState({modal: false})
  }

  render() {
    const store = this.props.store.paperTrading.debug
    const disabledDate = current => current > moment(new Date())
    return (
      <div>
        <Modal visible={this.state.modal} close={this.closeModal}/>
        <Spin size='large' spinning={!this.props.store.user.data.is_staff && !this.props.store.user.data.is_superuser}>
          <div styleName='container'>
            <div className='card'>
              <Spin size='large' spinning={store.running}>
                {store.message}
                <form onSubmit={this.submitHandler}>
                  <DatePicker
                    placeholder='Start Date'
                    onChange={this.changeHandler}
                    value={moment(store.startDate)}
                    disabledDate={disabledDate}
                  />
                  <button type='submit' disabled={store.running || !store.startDate}>Run</button>
                </form>
              </Spin>
            </div>
          </div>
        </Spin>
      </div>
    )
  }
}

export default Debug
